module.exports = __webpack_public_path__ + "img/20e2d03.jpg";